import { render, staticRenderFns } from "./SalesOrderHeader.vue?vue&type=template&id=1572b7e5"
import script from "./SalesOrderHeader.vue?vue&type=script&lang=js"
export * from "./SalesOrderHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1572b7e5')) {
      api.createRecord('1572b7e5', component.options)
    } else {
      api.reload('1572b7e5', component.options)
    }
    module.hot.accept("./SalesOrderHeader.vue?vue&type=template&id=1572b7e5", function () {
      api.rerender('1572b7e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/SalesOrderHeader.vue"
export default component.exports